var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38009 12.4912L13.5823 12.4912C13.7443 12.4912 13.8772 12.5432 13.9811 12.6471C14.085 12.751 14.137 12.884 14.137 13.0459C14.137 13.2079 14.085 13.3408 13.9811 13.4447C13.8772 13.5486 13.7443 13.6006 13.5823 13.6006L1.38009 13.6006C1.21813 13.6006 1.0852 13.5486 0.981295 13.4447C0.877391 13.3408 0.825439 13.2079 0.825439 13.0459C0.825439 12.884 0.877391 12.751 0.981295 12.6471C1.0852 12.5432 1.21813 12.4912 1.38009 12.4912ZM8.03585 8.08883L12.1264 3.99814L12.924 4.77801L7.42962 10.2726L1.93529 4.77801L2.71512 3.99814L6.92711 8.2103L6.92711 0.289062L8.0364 0.289062V8.08939L8.03585 8.08883Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTemplate);
export default __webpack_public_path__ + "static/media/download_template.36a23b548ae1458128499a3bf09fda75.svg";
export { ForwardRef as ReactComponent };